module.exports = __webpack_public_path__ + "static/media/6.658594e0.png";